import styles from "./Card.module.css";

function Card({ image, altImage, titulo, descricao }) {
  return (
    <div className={styles.container}>
      <img src={image} alt={altImage} className={styles.imageCard} />
      <h3>{titulo}</h3>
      <p>{descricao}</p>
    </div>
  );
}

export default Card;
